module.exports = __webpack_public_path__ + "static/media/SFCompactDisplay-Regular.bc2adab9.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/sf-ui-text/SFCompactDisplay-Regular.otf
// module id = 750
// module chunks = 0